import {
  FunctionComponent,
  ReactNode,
  useCallback,
  useRef,
  useState,
} from 'react'

import styled, { css } from 'styled-components'

import { mobileCSS } from '@measures/responsive'
import SwiperArrows from '@components/FollowMyTeamOverview/FollowMyTeamOverviewWithSubscriptions/SwiperArrows'
import Swiper, { ArrowsVisibilityType, SwiperClass } from '@components/Swiper'

type SwiperProps = {
  items: ReactNode[]
  currentSearchTerm: string
}

const StyledSwiper = styled(Swiper)<Pick<SwiperProps, 'currentSearchTerm'>>`
  ${({
    theme: {
      spacing: { spacing8, spacing40, spacing16 },
    },
    currentSearchTerm,
  }) => css`
    display: ${currentSearchTerm ? 'none' : 'block'};
    min-height: ${spacing40};
    margin-bottom: ${spacing8};
    ${mobileCSS(css`
      padding: 0;
      width: calc(100% + ${spacing16});
      margin-right: -${spacing16};
    `)}

    > .swiper-items-container {
      scroll-margin-left: ${spacing8};
      align-items: center;
      > *:first-child {
        ${mobileCSS(css`
          margin-left: 0;
          scroll-margin-left: 0;
        `)}
      }
      > *:nth-last-child(-n + 2) {
        scroll-margin-right: 81px;
      }
    }
  `}
`

const StyledSwiperArrows = styled(SwiperArrows)<{ itemsCount: number }>`
  ${({ itemsCount }) => css`
    > * {
      right: 0;
    }

    ${itemsCount <= 3 &&
    css`
      display: none;
    `}
  `}
`

const TeamFilterSwiper: FunctionComponent<SwiperProps> = ({
  items,
  currentSearchTerm,
}) => {
  const swiperRef = useRef<SwiperClass | null>(null)

  const [arrowsVisibility, setArrowsVisibility] =
    useState<ArrowsVisibilityType>()

  const onInit = useCallback(
    (swiper: any) => {
      if (swiperRef) {
        swiperRef.current = swiper
      }
    },
    [swiperRef],
  )

  const onArrowsVisibility = useCallback((arrow: ArrowsVisibilityType) => {
    setArrowsVisibility(arrow)
  }, [])

  return (
    <StyledSwiper
      initialSlide={0}
      spaceTopBottom={0}
      slidesPerGroup={1}
      spaceBetween={8}
      onInit={onInit}
      onArrowsVisibility={onArrowsVisibility}
      slides={items}
      currentSearchTerm={currentSearchTerm}
    >
      {arrowsVisibility && arrowsVisibility !== 'none' && (
        <StyledSwiperArrows
          swiperRef={swiperRef}
          arrowsVisibility={arrowsVisibility}
          itemsCount={items?.length ?? 0}
        />
      )}
    </StyledSwiper>
  )
}

export default TeamFilterSwiper
